import { API_BASE_URL_ENV } from "../common/common";
import BaseService from "./BaseService";
import http from "./HttpService";

export default class Service extends BaseService {
	getList(type) {
		return http.get(`${API_BASE_URL_ENV()}/${type}`);
	}
}
